<template lang="html">
  <div class="si-logo">
    <span
      class="font-weight-bold text-uppercasexx"
      :class="colorClass.primary"
      :style="style"
    >Super </span>
    <span
      class="font-weight-bold text-uppercasexx"
      :class="colorClass.secondary"
      :style="style"
    >Info</span>
  </div>
</template>

<script>
export default {
  props: {
    size: [ String, Number ],
    grey: Boolean,
    textClass: String,
    dark: Boolean
  },
  data () {
    return {

    }
  },
  computed: {
    // ...mapGetters([]),
    style () {
      return `font-size: ${this.size}px; line-height: ${Number(this.size) + 8}px`
    },
    colorClass () {
      if (this.textClass) {
        return {
          primary: this.textClass,
          secondary: this.textClass
        }
      } else {
        return {
          primary: this.dark ? 'white--text' : 'primary--text',
          secondary: this.dark ? 'primary--text' : 'secondary--textprimary'
        }
      }
    }
  },
  methods: {

  }
}
</script>

<style lang="css" scoped>
  .si-logo {
    white-space: nowrap;
  }
</style>
